'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_display_TooltipWrapper_TooltipWrapper = require('../TooltipWrapper/TooltipWrapper.cjs.js');
const components_display_Avatar_Avatar = require('./Avatar.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const AvatarWithTooltip = (_a) => {
  var { position } = _a, props = tslib_es6.__rest(_a, ["position"]);
  return React__default.default.createElement(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { content: props.name, position }, ({ childProps }) => React__default.default.createElement(components_display_Avatar_Avatar.Avatar, Object.assign({}, childProps, props, { isBlock: true })));
};

exports.AvatarWithTooltip = AvatarWithTooltip;
//# sourceMappingURL=AvatarWithTooltip.cjs.js.map
